/**
 * Small page-specific behaviours relocated from inline <script> blocks. Each is
 * guarded by the presence of its target elements, so bundling them for every
 * client page is harmless — they no-op where their markup is absent.
 */

// ── Orders page: product carousel ─────────────────────────────────────────────
(function () {
    function updateOrderCarousel(carousel) {
        var rail = carousel.querySelector('.ord-products-grid');
        var previous = carousel.querySelector('.ord-carousel-prev');
        var next = carousel.querySelector('.ord-carousel-next');
        if (!rail || !previous || !next) return;
        var maximum = Math.max(0, rail.scrollWidth - rail.clientWidth);
        var hasOverflow = maximum > 2;
        carousel.classList.toggle('is-overflowing', hasOverflow);
        previous.disabled = !hasOverflow || rail.scrollLeft <= 2;
        next.disabled = !hasOverflow || rail.scrollLeft >= maximum - 2;
    }
    function scrollOrderCards(control, direction) {
        var carousel = control.closest('.ord-products-carousel');
        var rail = carousel && carousel.querySelector('.ord-products-grid');
        var card = rail && rail.querySelector('.product-card-wrap');
        if (!rail || !card) return;
        var gap = parseFloat(getComputedStyle(rail).gap) || 0;
        rail.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    }
    function initialiseOrderCarousels() {
        document.querySelectorAll('.ord-products-carousel').forEach(function (carousel) {
            var rail = carousel.querySelector('.ord-products-grid');
            if (!rail) return;
            if (!rail.dataset.carouselReady) {
                rail.dataset.carouselReady = 'true';
                rail.addEventListener('scroll', function () { updateOrderCarousel(carousel); }, { passive: true });
            }
            updateOrderCarousel(carousel);
        });
    }
    // Replaces the former inline onclick="scrollOrderCards(this, ±1)".
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-carousel-scroll]');
        if (!btn) return;
        scrollOrderCards(btn, parseInt(btn.getAttribute('data-carousel-scroll'), 10) || 0);
    });
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialiseOrderCarousels, { once: true });
    } else {
        initialiseOrderCarousels();
    }
    window.addEventListener('resize', initialiseOrderCarousels);
}());

// ── Orders list: debounced search + sort navigation ───────────────────────────
(function () {
    function init() {
        var searchInput = document.getElementById('order-search');
        var sortSelect = document.getElementById('order-sort');
        if (!searchInput && !sortSelect) return;
        function navigate(url) {
            if (window.ajaxNavigate) { window.ajaxNavigate(url.toString()); }
            else { window.location = url.toString(); }
        }
        if (searchInput) {
            var timer;
            searchInput.addEventListener('input', function () {
                clearTimeout(timer);
                timer = setTimeout(function () {
                    var url = new URL(window.location.href);
                    var val = searchInput.value.trim();
                    if (val) { url.searchParams.set('search', val); } else { url.searchParams.delete('search'); }
                    navigate(url);
                }, 500);
            });
        }
        if (sortSelect) {
            sortSelect.addEventListener('change', function () {
                var url = new URL(window.location.href);
                if (this.value) { url.searchParams.set('sort', this.value); } else { url.searchParams.delete('sort'); }
                navigate(url);
            });
        }
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
        init();
    }
}());

// ── Pending flash messages (server-queued, rendered on next page) ─────────────
(function () {
    function init() {
        var island = document.getElementById('mero-pending-messages');
        if (!island) return;
        var msgs;
        try { msgs = JSON.parse(island.textContent || '[]'); } catch (_) { return; }
        if (!Array.isArray(msgs)) return;
        msgs.forEach(function (message) {
            if (typeof FOSSBilling !== 'undefined' && FOSSBilling.message) FOSSBilling.message(message);
        });
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
        init();
    }
}());


// ── Client profile: edit + change-password forms (guarded to the profile page) ──
(function(){
  function boot(){
(function () {
    if (!document.getElementById('form-profile-update') && !document.getElementById('form-change-password')) return;
    function togglePw(id, btn) {
        var input = document.getElementById(id);
        input.type = input.type === 'password' ? 'text' : 'password';
        var svg = btn.querySelector('svg');
        if (input.type === 'text') {
            svg.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/>';
        } else {
            svg.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>';
        }
    }

    function setLoading(btn, spinner, loading, label, savingText) {
        btn.disabled = loading;
        spinner.classList.toggle('hidden', !loading);
        if (label) label.textContent = loading ? (savingText || 'Saving…') : label.dataset.idle;
    }

    function showInlineMsg(el, text, isSuccess, autoHideMs) {
        el.textContent = text;
        el.className = 'text-xs font-medium ' + (isSuccess ? 'text-green-600' : 'text-red-500');
        el.classList.remove('hidden');
        clearTimeout(el._timer);
        el._timer = setTimeout(function () {
            el.classList.add('hidden');
            el.textContent = '';
        }, autoHideMs || 4000);
    }

    function collectForm(form) {
        var data = {};
        new FormData(form).forEach(function (v, k) { data[k] = v; });
        return data;
    }

    document.addEventListener('click', function (e) {
        var b = e.target.closest('[data-toggle-pw]');
        if (b) togglePw(b.getAttribute('data-toggle-pw'), b);
    });

    // ── Profile update ────────────────────────────────────────────────────
    var profileLabel     = document.getElementById('btn-save-profile-label');
    var profileInlineMsg = document.getElementById('profile-inline-msg');
    profileLabel.dataset.idle = profileLabel.textContent;
    document.getElementById('form-profile-update').addEventListener('submit', function (e) {
        e.preventDefault();
        var btn     = document.getElementById('btn-save-profile');
        var spinner = document.getElementById('btn-save-profile-spinner');
        setLoading(btn, spinner, true, profileLabel);
        API.client.post('profile/update', collectForm(this), function () {
            setLoading(btn, spinner, false, profileLabel);
            showInlineMsg(profileInlineMsg, '✓ Saved successfully', true);
            // Exit edit mode — find the Alpine section and set editing=false
            var section = document.getElementById('form-profile-update').closest('[x-data]');
            if (section && section._x_dataStack) {
                section._x_dataStack[0].editing = false;
            }
        }, function (err) {
            setLoading(btn, spinner, false, profileLabel);
            showInlineMsg(profileInlineMsg, (err && err.message ? err.message : 'Failed to save'), false);
        });
    });

    // ── Change password ───────────────────────────────────────────────────
    var pwInlineMsg = document.getElementById('password-inline-msg');
    document.getElementById('form-change-password').addEventListener('submit', function (e) {
        e.preventDefault();
        var btn     = document.getElementById('btn-change-password');
        var spinner = document.getElementById('btn-change-password-spinner');
        var data    = collectForm(this);
        if (data.new_password !== data.confirm_password) {
            showInlineMsg(pwInlineMsg, 'Passwords do not match', false);
            return;
        }
        setLoading(btn, spinner, true);
        API.client.post('profile/change_password', data, function () {
            setLoading(btn, spinner, false);
            showInlineMsg(pwInlineMsg, '✓ Password updated', true);
            document.getElementById('form-change-password').reset();
        }, function (err) {
            setLoading(btn, spinner, false);
            showInlineMsg(pwInlineMsg, (err && err.message ? err.message : 'Failed to update password'), false);
        });
    });
}());
  }
  if (document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot,{once:true});}else{boot();}
}());

// Hosting control-panel URLs are generated by the authenticated API wrapper.
window.servicesControlPanelLogin = function (url) {
    window.location.assign(url);
};
